export default function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/888366b0d7c4742a3046bc1121387cda.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-teal-500/20 backdrop-blur-sm rounded-full mb-8">
          <i className="ri-building-4-fill text-teal-400 text-5xl"></i>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Sell My Apartments Fast<br />
          <span className="text-teal-400">Cash Apartment Buyers El Paso</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed">
          Professional apartment buyers with a proven track record. We buy apartment buildings fast, close with a trusted title company, and make the entire process seamless for property owners in El Paso, Texas.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <button 
            onClick={scrollToContact}
            className="px-10 py-5 bg-teal-600 text-white rounded-lg font-bold text-lg hover:bg-teal-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Get My Cash Offer Now
          </button>
          <a 
            href="tel://+19152065814"
            className="px-10 py-5 bg-white text-gray-900 rounded-lg font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Fast Closings</h3>
            <p className="text-gray-200">Close in as little as 7-14 days with our streamlined process</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Title Company Security</h3>
            <p className="text-gray-200">All transactions handled through reputable title companies</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-trophy-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Proven Track Record</h3>
            <p className="text-gray-200">Over 40 years of combined experience and countless purchases</p>
          </div>
        </div>
      </div>
    </section>
  );
}